import { render, staticRenderFns } from "./floor.vue?vue&type=template&id=f6046dce&"
import script from "./floor.vue?vue&type=script&lang=js&"
export * from "./floor.vue?vue&type=script&lang=js&"
import style0 from "./floor.vue?vue&type=style&index=0&id=f6046dce&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports